import React, { useState, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { Form } from 'react-bootstrap';

import config from "../../Config";
import SupportTopMenu from "./SupportTopMenu";
import SupportTicketDropDown from "../Shared/SupportTicketDropDown";
import SupportFileAttachment from "./SupportFileAttachment";

function NewTicket(props) {


    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [TicketsLoading, setTicketsLoading] = useState(false);

    const [tickets, setTickets] = useState([]);

    const [AttachmentString, setAttachmentString] = useState("");

    let navigate = useNavigate();

    useEffect(() => {

        setTicketsLoading(true);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            Status: "Open",

        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'Support/GetTicketTypesByStatusMemberID',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };


        axios(api_config)
            .then(function (response) {
                if (response.data.status_code == 1) {
                    setTickets(response.data.ListofTickets);
                }

                setTicketsLoading(false);
            })
            .catch(function (error) {
                //console.log(error);
            });



    }, []);


    const handleSubmit = (event) => {

        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            setLoading(true);
            const data = {
                UserID: UserID,
                AccessKey: AccessKey,
                Subject: event.target.subject.value,
                Description: event.target.description.value,
                TicketType: event.target.type.value,
                FileAttached: AttachmentString,
            };
            //console.log(data);
            var api_config = {
                method: 'post',
                url: config.base_url + 'Support/AddSupportTicket',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            axios(api_config)
                .then(function (response) {

                    //console.log(response.data);

                    if (response.data.status_code == 1) {

                        toast.success(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        navigate("/support/open");
                    }
                    else {
                        toast.error(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                    }

                    setLoading(false);

                })
                .catch(function (error) {
                    setLoading(false);
                    toast.error('Network Error..', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                });

        }

        setValidated(true);
    };



    return (
        <>
            <ToastContainer />
            <SupportTopMenu />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"> <Link to="/support/raise-ticket">Support</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Raise ticket</li>
                                </ol>
                            </nav>
                            <div className="page-title">Raise ticket</div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="container">
                <div className="card">
                    <div className="card-body p-md-4">
                        <div className="row">
                            <div className="form_default col-12">

                                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                    <div style={{ padding: "20px 40px" }}>
                                        <div className="row gy-3">
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label className="">Subject</label>
                                                    <div className="inputwrap">
                                                        <input type="text" placeholder="Subject" className="form-control" name="subject" maxLength={20} required />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <div className="form-group">
                                                    <label className="">Department</label>
                                                    <div className="inputwrap">
                                                        <select className="form-select" name="type" required>
                                                            <option value="">Select Department</option>
                                                            <SupportTicketDropDown />
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-11">
                                                <div className="form-group">
                                                    <label className="">Message</label>
                                                    <div className="inputwrap">
                                                        <textarea className="form-control" placeholder="Message" name="description" rows="6" required></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <label className="form-label">Attachment (optional)</label>
                                                <SupportFileAttachment
                                                    value={AttachmentString}
                                                    onChange={setAttachmentString}
                                                    inputId="StaffNewTicketAttach"
                                                    disabled={loading}
                                                />
                                            </div>
                                            <div className="col-md-4 offset-md-4 text-end">
                                                <button className="button button-primary" disabled={loading}>SUBMIT TICKET {loading ? '...' : ''}</button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>

                    </div>
                </div>
            </div >

        </>
    );
}

export default NewTicket;
